import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "38",
  height: "38",
  fill: "none",
  viewBox: "0 0 41 42"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#a)\"><circle cx=\"20.5\" cy=\"20.35\" r=\"19\" fill=\"#636E96\" fill-opacity=\".3\" stroke=\"#CEEC34\"></circle><circle cx=\"20.5\" cy=\"20.35\" r=\"12.3\" fill=\"#23283B\"></circle><path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M21.247 18.77h3.5M17.253 18.77l.5.5 1.5-1.5M21.247 23.437h3.5M17.253 23.437l.5.5 1.5-1.5\"></path><path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M19 27.517h4c3.333 0 4.666-1.333 4.666-4.667v-4c0-3.333-1.333-4.666-4.666-4.666h-4c-3.334 0-4.667 1.333-4.667 4.666v4c0 3.334 1.333 4.667 4.667 4.667\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 .85h41v41H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }